import React from 'react';
import { Link } from 'react-router-dom';
import { useObservable } from 'react-use-observable';

import { Badge } from 'antd';

import { ENotificationType } from 'v2/interfaces/notification';
import notificationService from 'v2/services/notifications';

export default function BankslipGenerated() {
  const [notifications] = useObservable(() => notificationService.getListGroupNotifications(), []);
  const bankslips = notifications?.find(notification => notification.type === ENotificationType.BANKSLIP_GENERATED);

  if (!bankslips?.quantity) return null;

  const quantity = bankslips.quantity || 0;

  return (
    <Link to={`/producer/notifications/${ENotificationType.BANKSLIP_GENERATED}`}>
      <div className='flex items-center justify-between px-4 py-2.5 transition-colors hover:bg-[#f5f5f5]'>
        <span className='text-sm font-medium text-[#37474f]'>Boletos Gerados</span>
        <Badge count={quantity} color='blue' showZero />
      </div>
    </Link>
  );
}
